<script>
    import SubBasic from './sub/subBasic.svelte'
    import SubSkill from './sub/subSkill.svelte'

    export let OnCapture, MonsterData, DataCheck

    let activeTab = 1, Section = -1

    function onClickTab(_tab) {
        activeTab = _tab

        if(_tab >= 2) {
            Section = _tab - 2
        }
    }
</script>

<div class='monster'>
    <div class="left">
        <img
            src="../img/monsters/{MonsterData.monster}/monster.png"
            alt="{MonsterData.monster}"
        >
        <div class="name">{MonsterData.name}</div>
    </div>

    <svg xmlns="http://www.w3.org/2000/svg" width="51" height="12" viewBox="0 0 51 12" fill="none">
        <line x1="3" y1="5.5" x2="45" y2="5.5" stroke="#7A67FF" stroke-width="3"/>
        <rect x="39" y="5.53564" width="7.82858" height="7.82858" transform="rotate(-45 39 5.53564)" fill="#7A67FF"/>
        <rect y="5.53564" width="7.82858" height="7.82858" transform="rotate(-45 0 5.53564)" fill="#7A67FF"/>
    </svg>

    <div class="right">
        {#if !OnCapture}
            <div class="menu">
                <div class="tab top"
                    class:active={activeTab == 1}
                    on:click={() => onClickTab(1)}
                >
                    기본
                </div>

                <div class="tab middle"
                    class:active={activeTab == 2}
                    on:click={() => onClickTab(2)}
                >
                    액티브
                </div>
                
                <div class="tab bottom"
                    class:active={activeTab == 3}
                    on:click={() => onClickTab(3)}
                >
                    패시브
                </div>
            </div>
        {/if}

        {#if !OnCapture}
            <div class="inputPage">
                {#if activeTab == 1}
                    <SubBasic
                        bind:Temperament={MonsterData.temperament}
                        bind:Equipment={MonsterData.equipment}
                    />
                {:else if activeTab == 2}
                    <SubSkill
                        bind:Monster={MonsterData.monster}
                        bind:Section
                        bind:Skills={MonsterData.skills[0]}
                        bind:DataCheck
                    />
                {:else if activeTab == 3}
                    <SubSkill
                        bind:Monster={MonsterData.monster}
                        bind:Section
                        bind:Skills={MonsterData.skills[1]}
                        bind:DataCheck
                    />
                {/if}
            </div>
        {:else}
            <div class="inputPage" class:OnCapture>
                <SubBasic
                    bind:Temperament={MonsterData.temperament}
                    bind:Equipment={MonsterData.equipment}
                />
            </div>

            <div class="inputPage" class:OnCapture>
                <SubSkill
                    bind:Monster={MonsterData.monster}
                    Section = 0
                    bind:Skills={MonsterData.skills[0]}
                    bind:DataCheck
                />
            </div>

            <div class="inputPage" class:OnCapture>
                <SubSkill
                    bind:Monster={MonsterData.monster}
                    Section = 1
                    bind:Skills={MonsterData.skills[1]}
                    bind:DataCheck
                />
            </div>
        {/if}
    </div>
</div>

<style lang="scss">
    .monster {
        width: calc(100%);
        height: fit-content;

        .left {
            width: calc(25% - 26px);
            height: fit-content;
            text-align: center;
            display: inline-block;
            vertical-align: middle;

            img { width: 100%; margin-bottom: 9px; }
            .name {
                color: $cl3;
                font-size: 15px;
                font-family: aggro;
            }
        }

        svg { display: inline-block; }

        .right {
            width: calc(75% - 26px);
            height: fit-content;
            display: inline-block;
            vertical-align: top;
            
            .menu {
                display: inline-block;

                .tab {
                    background: $cl2;
                    width: fit-content;
                    height: fit-content;
                    padding: 10px 6px;
                    color: $cl3;
                    font-size: 14px;
                    font-family: aggro;
                    writing-mode: vertical-lr;

                    &.active {
                        background: $cl3;
                        color: $cl2;
                    }

                    &:hover:not(.active) {
                        background: $cl3;
                        color: $cl2;
                        cursor: pointer;
                    }
                }
            }
        
            .inputPage {
                width: calc(100% - 40px - 4px - 35px);
                height: fit-content;
                min-height: calc(196px - 20px - 4px);
                padding: 20px;
                padding-bottom: 0;
                border: 2px solid $cl3;
                display: inline-block;
                vertical-align: top;
            }

            .OnCapture {
                margin: 5px 0px;
            }
        }

        
        @include mobile {
            .left, svg { display: none; }
            .right {
                width: calc(100%);

                .menu .tab { font-size: 12px;}
                .inputPage {
                    width: calc(100% - 20px - 4px - 35px);
                    min-height: calc(180px - 20px - 4px);
                    padding: 10px;
                }
            }
        }
    }
</style>